import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from '../../../../cms/blocks/types.gen'
import { Form } from '../../../../form'
import { FormState } from '../../../../form/types'
import { formBlockData } from '../types.mod'

export type formBlockProps = {
  block_index: number
  form_id: string
  state: FormState
}

export type formBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
}>

export function formBlock(
  props: formBlockProps,
  options?: { style: formBlockStyle; key?: string }
): (
  s: CMSState
) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX<Updater<CMSState>>((setState) => (
        <section className="block block--form block-bg--grey ls-block-spacing">
          <div className="block__inner ls-container">
            <div className="block__layout ls-columns">
              <div className="ls-columns__main">
                {Form(props.state).run((updater) => {
                  setState((s: CMSState) => {
                    const currentBlock = s.blocks.get(props.block_index)
                    if (currentBlock == undefined || currentBlock.kind !== 'formBlock') return s
                    const new_state = updater(currentBlock.value[0].state)
                    if (new_state.form_submission_logic.kind == 'loaded')
                      if (!window.dataLayer.find((layer) => layer.action == 'Form'))
                        window.dataLayer.push({
                          event: `event.${sitename}`,
                          category: 'Contact',
                          action: 'Form',
                          label: window.location.pathname
                        })
                    const new_block = {
                      ...currentBlock,
                      value: [
                        { ...currentBlock.value[0], state: { ...new_state } },
                        currentBlock.value[1]
                      ]
                    } as formBlockData
                    return { ...s, blocks: s.blocks.set(props.block_index, new_block) }
                  })
                })}
              </div>
            </div>
          </div>
        </section>
      )
    )
}
